import {EnkelBrukerModell, TynnFavorittModell} from "../tjenester/ressurser/generertNg2HttpKlient";
import {BrukerkontekstTilbyder} from "../tjenester/BrukerkontekstTilbyder";
import {nil} from "felles-ng2/typer/nullish";

/** Sann dersom angitte favoritter inneholder angitt bruker.
 * Se også favorittModellHjelpere.ts  */
export function erFavorittHosBruker(favoritter: TynnFavorittModell[], kontekst: BrukerkontekstTilbyder): boolean {
    if (kontekst.erIkkeAutentisert()) return false;
    return favoritter.some(favoritt => favoritt.brukerId === kontekst.autentisertBruker().bruker.id);
}

export function sorterBrukerPåEpostEllerNavn(a: Pick<EnkelBrukerModell, 'navnEllerEpost'> | nil, b: Pick<EnkelBrukerModell, 'navnEllerEpost'> | nil): number {
    return (a?.navnEllerEpost ?? '').localeCompare(b?.navnEllerEpost ?? '');
}
